import React, { useState, useEffect } from 'react'
import AddressSection from '../../../components/ProfileForm/AddressSection'
import GPDetailsSection from '../../../components/ProfileForm/GPDetailsSection'

const Address = ({ data, gpData, onChange, onGpChange, onValidityChange, dependant }) => {
  const [userInfo, setUserInfo] = useState({
    address: {
      addressLine1: data.addressLine1 || '',
      addressLine2: data.addressLine2 || '',
      city: data.city || '',
      postcode: data.postcode || '',
      country: 'United Kingdom',
    },
  })

  const [profileData, setProfileData] = useState({
    phone_number: data.phone || '',
  })

  // GP related state
  const [selectedGP, setSelectedGP] = useState(gpData?.name ? gpData : null)
  const [showGpMap, setShowGpMap] = useState(false)
  const [enterDetailsManually, setEnterDetailsManually] = useState(false)
  const [isNotRegisteredWithGP, setIsNotRegisteredWithGP] = useState(false)
  const [manualDetails, setManualDetails] = useState({
    name: gpData?.name || '',
    addressLine1: gpData?.address?.addressLine1 || gpData?.addressLine1 || '',
    addressLine2: gpData?.address?.addressLine2 || gpData?.addressLine2 || '',
    city: gpData?.address?.city || gpData?.city || '',
    postcode: gpData?.address?.postcode ||  gpData?.postcode || '',
    country: gpData?.address?.country || 'United Kingdom',
    phone: gpData?.phone || '',
    email: gpData?.email || '',
  })


  const handleClearSelectedGP = () => {
    setSelectedGP(null)
    setEnterDetailsManually(false)
    setManualDetails({
      name: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      postcode: '',
      country: 'United Kingdom',
      phone: '',
      email: '',
    })
    setIsNotRegisteredWithGP(false)
    setShowGpMap(false)
  }

  const handleEditSelectedGP = () => {
    if (!selectedGP) return
    setEnterDetailsManually(true)
    const parts = selectedGP.address
      ? selectedGP.address.split(',').map((part) => part.trim())
      : []
    const line1 = parts[0] || ''
    const line2 = parts[1] || ''
    const town = parts[2] || ''

    setManualDetails({
      name: selectedGP.name || selectedGP.surgeryName || '',
      addressLine1: line1 || '',
      addressLine2: line2 || '',
      city: town || '',
      postcode: selectedGP.postcode || '',
      country: selectedGP.country || 'United Kingdom',
      phone: selectedGP.phone || '',
      email: selectedGP.email || '',
    })
  }

  const validate = () => {
    const requiredClientFields = ['addressLine1', 'city', 'postcode']
    const isClientAddressValid = requiredClientFields.every((field) =>
      userInfo.address[field]?.trim()
    )

    const isManualGPValid = !!(
      enterDetailsManually &&
      manualDetails?.name?.trim() &&
      manualDetails?.addressLine1?.trim() &&
      manualDetails?.city?.trim() &&
      manualDetails?.postcode?.trim()
    )

    const isGPValid =
      (!!selectedGP && Object.keys(selectedGP).length > 0) ||
      isManualGPValid ||
      isNotRegisteredWithGP

    return isClientAddressValid && isGPValid
  }

  useEffect(() => {
    const valid = validate()
    if (typeof onValidityChange === 'function') {
      onValidityChange(valid)
    }

    // Update parent with address data
    onChange('addressLine1', userInfo.address.addressLine1)
    onChange('addressLine2', userInfo.address.addressLine2)
    onChange('city', userInfo.address.city)
    onChange('postcode', userInfo.address.postcode)
    onChange('phone', profileData.phone_number)

    // Update parent with GP data
    const gpDataToSend = selectedGP || manualDetails
    if (typeof onGpChange === 'function') {
      onGpChange(gpDataToSend)
    }
  }, [
    userInfo,
    profileData,
    selectedGP,
    manualDetails,
    isNotRegisteredWithGP,
    enterDetailsManually,
  ])


  return (
    <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-6">
      <AddressSection
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        profileData={profileData}
        setProfileData={setProfileData}
        showTitle={true}
        showEditing={false}
        dependant={dependant}
      />

      <GPDetailsSection
        selectedGP={selectedGP}
        setSelectedGP={setSelectedGP}
        showGpMap={showGpMap}
        setShowGpMap={setShowGpMap}
        enterDetailsManually={enterDetailsManually}
        setEnterDetailsManually={setEnterDetailsManually}
        manualDetails={manualDetails}
        setManualDetails={setManualDetails}
        isNotRegisteredWithGP={isNotRegisteredWithGP}
        setIsNotRegisteredWithGP={setIsNotRegisteredWithGP}
        handleClearSelectedGP={handleClearSelectedGP}
        handleEditSelectedGP={handleEditSelectedGP}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        showTitle={true}
        dependant={dependant}
        alterText={true}
      />
    </div>
  )
}

export default Address
